/**
 * -------------------------------------------------------
 * NOTE: This is a generated file, do not manually modify!
 * -------------------------------------------------------
 */
export var radius = {
    '100': { pixels: 4, px: '4px', rem: '0.25rem' },
    '200': { pixels: 8, px: '8px', rem: '0.5rem' },
    '300': { pixels: 12, px: '12px', rem: '0.75rem' },
    '400': { pixels: 16, px: '16px', rem: '1rem' },
    '1000': {
        pixels: 999,
        px: '999px',
        rem: '62.4375rem',
        percent: '100%',
    },
};
